import { CurrencyCalculator } from '@/components/calculator/Calculator';
import { CurrencyImage } from '@/components/image/Image';
import { CurrencyLinkTree } from '@/components/linkTree/LinkTree';
import { CurrencyList } from '@/components/list/List';
import type { CurrencyData } from '@/interfaces';

type Props = { currencies: CurrencyData };

const Landing = ({ currencies }: Props) => {
    const updatedText = currencies.updated ? `ble oppdatert ${currencies.updated.short} kl ${currencies.updated.time},` : 'hentes';

    return (
        <>
            <h1 className="h2">Valutakalkulator</h1>
            <section className="md:grid md:grid-cols-3 items-center mb-32" aria-label="Valutakalkulator">
                <div className="md:col-span-2">
                    <CurrencyCalculator data={currencies.data} />
                </div>
                <CurrencyImage />
            </section>

            {currencies.data ? (
                <section className="my-32 md:grid md:grid-cols-3" aria-label="Valutakurser">
                    <div className="md:col-span-2">
                        <CurrencyList data={currencies.data} date={currencies.updated?.date} />
                    </div>
                </section>
            ) : (
                <section className="my-32 p-16 sm:p-32 s-bg-negative-subtle rounded-8" aria-label="Feilmelding">
                    Ooops... En feil oppsto under henting av valuta data, vennligst prøv igjen.
                </section>
            )}

            <section className="my-32 text-12 s-text-subtle" aria-label="Informasjon">
                Kursene {updatedText} fra valutakurslistene til DNB. Husk at dette kan avvike fra kursen du får i banken din.
                <br />
                <br />
                Det kan være lurt å forberede seg litt før man reiser, og det å sjekke valutakursene er ingen dum idé. Hvor mye er pengene
                dine verdt? På FINN.nos valutakalkulator finner du oppdaterte valutakurser fra hele verden, blant annet dollar, pund, euro,
                baht og danske kroner. Hvis du skal ta med deg mer enn 25 000 norske kroner til eller fra Norge, må du huske å melde fra til
                Tollvesenet.
            </section>

            <section className="my-32" aria-label="Populære destinasjoner">
                <h2 className="h3 text-center mb-32">Populære destinasjoner</h2>
                <CurrencyLinkTree />
            </section>
        </>
    );
};

export default Landing;
